import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

// 闪送员装备认证
export default [
  {
    path: '/courierView/equipCertification',
    component: Loadable({
      loader: () => import('@/pages/equipCertification/main'),
      loading: LoadingComponent
    })
  }
]
